export class MaterialLocationQuantity {
    id!: string
    material!: string
    location!: string
    quantity!: number
}
